import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getPreAuthClaim,
  intimateClaimIhx,
  patchPreAuthClaim,
  postPreAuthClaim,
  postPreAuthClaimIhx,
  postPreAuthClaimToEdgePro,
  postPreAuthClaimToEdgeProIhx,
} from "../apis/patientService";
import {
  IClaimRes,
  IClaimSubmissionResponse,
  IPreAuthClaimState,
  PreAuthClaimField,
  PreAuthClaimResponse,
  WizardStep,
} from "../interfaces/IPreAuthClaim";
import { errorMessage, successMessage } from "../utils/notificationUtils";
import {
  fetchSchemesOnBoardingById,
  getEchsProcedures,
  getProcedureList,
  getProcedures,
  getProceduresNew,
} from "../apis/schemeService";
import { ISchemeOnBoardById } from "../interfaces/IScheme";
import { uploadDocs } from "../apis/caseService";
import { IDocumentFields } from "../interfaces/ICase";
import { intimateClaimCghs, intimateClaimCghsNew, postPreAuthClaimCghs, postPreAuthClaimCghsNew, postPreAuthClaimToEdgeProCghs, postPreAuthClaimToEdgeProCghsNew } from "../apis/SchemeService/CGHS/cghsService";
import Axios from "../utils/axiosInterceptor";
import { intimateClaimEchs, postPreAuthClaimEchs, postPreAuthClaimToEdgeProEchs } from "../apis/SchemeService/ECHS/echsService";
import { intimateClaimAyushmanB, postPreAuthClaimAyushmanB, postPreAuthClaimToEdgeProAyushmanB } from "../apis/ayushmanBService";

const initialState: IPreAuthClaimState = {
  allWizardSteps: [
    // { step: 0, title: "Basic Details", canNavigate: true, completed: false },
    // { step: 1, title: "Billing Details", canNavigate: true, completed: false },
  ],
  activeStep: 0,
  uploadedDocumentUrl: [],
  localFiles: {},
  preAuthClaimRes: null,
  isFetchingClaimData: false,
  isFetchingSchemeById: false,
  isFetchingProcedure: false,
  error: null,
  editMode: false,
  isLoading: false,
  selectedScheme: null,
  CasePreAuthRes: null,
  editedFields: {},
  isSubmit: false,
  procedureDropDown: [],
  referralProcedures: [],
};

export const submitClaimSubmission = createAsyncThunk(
  "preAuthClaims/submitClaimSubmission",
  async ({
    data,
    caseId,
    visitId,
    portalId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
  }) => {
    const response = await postPreAuthClaim(data, caseId, visitId, portalId);
    return response;
  }
);

export const submitClaimSubmissionIhx = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionIhx",
  async ({
    data,
    caseId,
    visitId,
    portalId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
  }) => {
    const response = await postPreAuthClaimIhx(data, caseId, visitId, portalId);
    return response;
  }
);

export const submitClaimSubmissionCghs = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionCghs",
  async ({
    data,
    caseId,
    visitId,
    portalId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
  }) => {
    const response = await postPreAuthClaimCghs(data, caseId, visitId, portalId);
    return response;
  }
);

export const submitClaimSubmissionCghsNew = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionCghsNew",
  async ({
    data,
    caseId,
    visitId,
    portalId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
  }) => {
    const response = await postPreAuthClaimCghsNew(data, caseId, visitId, portalId);
    return response;
  }
);

export const submitClaimSubmissionEchs = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionEchs",
  async ({
    data,
    caseId,
    visitId,
    portalId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
  }) => {
    const response = await postPreAuthClaimEchs(data, caseId, visitId, portalId);
    return response;
  }
);

export const submitClaimSubmissionAyushmanB = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionAyushmanB",
  async ({
    data,
    caseId,
    visitId,
    portalId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
  }) => {
    const response = await postPreAuthClaimAyushmanB(data, caseId, visitId, portalId);
    return response;
  }
);

export const submitClaimSubmissionToEdgePro = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionToEdgePro",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await postPreAuthClaimToEdgePro(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const submitClaimSubmissionToEdgeProCghs = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionToEdgeProCghs",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await postPreAuthClaimToEdgeProCghs(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const submitClaimSubmissionToEdgeProCghsNew = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionToEdgeProCghsNew",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await postPreAuthClaimToEdgeProCghsNew(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const submitClaimSubmissionToEdgeProIhx = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionToEdgeProIhx",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await postPreAuthClaimToEdgeProIhx(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const submitClaimSubmissionToEdgeProEchs = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionToEdgeProEchs",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await postPreAuthClaimToEdgeProEchs(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const submitClaimSubmissionToEdgeProAyushmanB = createAsyncThunk(
  "preAuthClaims/submitClaimSubmissionToEdgeProAyushmanB",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await postPreAuthClaimToEdgeProAyushmanB(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const intimateClaimSubmissionIhx = createAsyncThunk(
  "preAuthClaims/intimateClaimSubmissionIhx",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await intimateClaimIhx(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const intimateClaimSubmissionEchs = createAsyncThunk(
  "preAuthClaims/intimateClaimSubmissionEchs",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await intimateClaimEchs(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const intimateClaimSubmissionAyushmanB = createAsyncThunk(
  "preAuthClaims/intimateClaimSubmissionAyushmanB",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await intimateClaimAyushmanB(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const intimateClaimSubmissionCghs = createAsyncThunk(
  "preAuthClaims/intimateClaimSubmissionCghs",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await intimateClaimCghs(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const intimateClaimSubmissionCghsNew = createAsyncThunk(
  "preAuthClaims/intimateClaimSubmissionCghsNew",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimId: number | null;
  }) => {
    const response = await intimateClaimCghsNew(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimId
    );
    return response;
  }
);

export const updateClaimSubmission = createAsyncThunk(
  "preAuthClaims/updateClaimSubmission",
  async ({
    data,
    caseId,
    visitId,
    portalId,
    caseClaimSubmissionId,
  }: {
    data: IClaimRes;
    caseId: number;
    visitId: number;
    portalId: number;
    caseClaimSubmissionId: number;
  }) => {
    const response = await patchPreAuthClaim(
      data,
      caseId,
      visitId,
      portalId,
      caseClaimSubmissionId
    );
    return response;
  }
);

export const fetchProcedure = createAsyncThunk(
  "preAuthClaims/fetchProcedures",
  async ({
    caseId,
    hospitalId,
    isCghs,
    procedureType,
    schemeId,
  }: {
    caseId: number | null;
    hospitalId: number;
    isCghs: boolean;
    procedureType: string;
    schemeId: number;
  }) => {
    const response = await getProcedures(
      caseId,
      hospitalId,
      isCghs,
      procedureType,
      schemeId
    );
    return response;
  }
);

export const fetchProcedureNew = createAsyncThunk(
  "preAuthClaims/fetchProcedureNew",
  async ({
    caseId,
    hospitalId,
    isCghs,
    procedureType,
    schemeId,
    benType
  }: {
    caseId: number | null;
    hospitalId: number;
    isCghs: boolean;
    procedureType: string;
    schemeId: number;
    benType: any;
  }) => {
    const response = await getProceduresNew(
      caseId,
      hospitalId,
      isCghs,
      procedureType,
      schemeId,
      benType
    );
    return response;
  }
);

export const fetchEchsProcedure = createAsyncThunk(
  "preAuthClaims/fetchEchsProcedure",
  async ({
    hospitalId,
    patientType,
    schemeId,
  }: {
    hospitalId: number;
    patientType: string;
    schemeId: number;
  }) => {
    const response = await getEchsProcedures(hospitalId, patientType, schemeId);
    return response;
  }
);

export const fetchSchemeById = createAsyncThunk(
  "preAuthClaims/fetchSchemeById",
  async (schemeMetaDataId: number) => {
    const response = await fetchSchemesOnBoardingById(schemeMetaDataId);
    return response;
  }
);

export const fetchProcedureList = createAsyncThunk(
  "preAuthClaims/fetchProcedureList",
  async ({ caseId, visitId }: { caseId: number; visitId: number }) => {
    const response = await getProcedureList(caseId, visitId);
    return response;
  }
);

export const UploadDocument = createAsyncThunk(
  "preAuthClaims/UploadDocument",
  async ({ formData, accessToken }: { formData: any; accessToken: string }) => {
    const response = await uploadDocs(formData, accessToken);
    return response;
  }
);

export const getClaimSubmission = createAsyncThunk(
  "preAuthClaims/getClaimSubmission",
  async ({
    caseId,
    visitId,
    portalId,
  }: {
    caseId: number;
    visitId: number;
    portalId: number;
  }) => {
    const response = await getPreAuthClaim(caseId, visitId, portalId);
    return response;
  }
);

const preAuthClaimSlice = createSlice({
  name: "preAuthClaims",
  initialState,
  reducers: {
    setWizardSteps: (state, action: PayloadAction<Array<WizardStep>>) => {
      state.allWizardSteps = action.payload;
    },
    resetProcedureDropdown: (state) => {
      state.procedureDropDown = [];
      state.referralProcedures = [];
    },
    updateWizardStep(state, action: PayloadAction<number>) {
      const newStep = action.payload;
      if (
        typeof newStep === "number" &&
        newStep >= 0 &&
        newStep < state.allWizardSteps.length
      ) {
        state.activeStep = newStep;
        state.allWizardSteps?.forEach((step, index) => {
          step.canNavigate =
            index <= newStep && (index === newStep || step.completed);
        });
      }
    },
    completeWizardStep(state, action: PayloadAction<number>) {
      const completedStep = action.payload;
      if (
        typeof completedStep === "number" &&
        completedStep >= 0 &&
        completedStep < state.allWizardSteps.length
      ) {
        state.allWizardSteps[completedStep].completed = true;
        state.allWizardSteps?.forEach((step, index) => {
          step.canNavigate =
            index <= completedStep &&
            (index === completedStep || step.completed);
        });
      }
    },
    addPreAuthClaimUploadedFile: (
      state,
      action: PayloadAction<{ file: any; docType: string }>
    ) => {
      const file = action.payload.file;
      const key = action.payload.docType;
      state.localFiles[`${key}`] = file;
    },
    removePreAuthClaimUploadedFile: (
      state,
      action: PayloadAction<{ docType: string }>
    ) => {
      const key = action.payload.docType;
      const { [key]: removed, ...rest } = state.localFiles;
      state.localFiles = rest;
    },
    addProcedure: (state, action: PayloadAction<Array<any>>) => {
      if (
        state.CasePreAuthRes?.casePreAuthCghs?.casePreAuthCghsProceduresList
      ) {
        state.CasePreAuthRes.casePreAuthCghs.casePreAuthCghsProceduresList =
          action.payload;
      }
    },
    setUploadedDocumentUrl(state, action: PayloadAction<Array<any>>) {
      state.uploadedDocumentUrl = action.payload;
    },
    resetUploadedDocumentUrl(state, action: PayloadAction<Array<any>>) {
      state.uploadedDocumentUrl = action.payload;
    },
    resetLocalFiles: (state) => {
      state.localFiles = {};
    },
    resetPreAuthClaimRes: (state) => {
      state.preAuthClaimRes = null;
      state.editedFields = {};
    },
    resetEditedFields: (state) => {
      state.editedFields = {};
    },
    updateField(
      state,
      action: PayloadAction<{
        sectionKey: string;
        fieldId: string | undefined;
        value: any;
      }>
    ) {
      const { sectionKey, fieldId, value } = action.payload;
      if (fieldId) {
        if (sectionKey === "all" && fieldId === "all") {
          state.editedFields = value;
        } else {
          if (!state.editedFields[sectionKey]) {
            state.editedFields[sectionKey] = {};
          }
          state.editedFields[sectionKey][fieldId] = value;
        }
      }
    },
    saveChanges(state) {
      if (state.preAuthClaimRes && state.editedFields) {
        const newDischargeData = JSON.parse(
          JSON.stringify(state.preAuthClaimRes)
        );
        Object.entries(state.editedFields)?.forEach(([sectionKey, fields]) => {
          const section =
            newDischargeData[sectionKey as keyof PreAuthClaimResponse];
          if (Array.isArray(section)) {
            section?.forEach((sectionData) => {
              Object.entries(fields)?.forEach(([fieldId, value]) => {
                const fieldIndex = sectionData[
                  Object.keys(sectionData)[0]
                ].findIndex((f: PreAuthClaimField) => f.id === fieldId);
                if (fieldIndex !== -1) {
                  sectionData[Object.keys(sectionData)[0]][fieldIndex] = {
                    ...sectionData[Object.keys(sectionData)[0]][fieldIndex],
                    data: value,
                  };
                }
              });
            });
          }
        });
        state.preAuthClaimRes = newDischargeData;
      }
      // state.editedFields = {};
    },
    toggleEditMode(state) {
      state.editMode = !state.editMode;
      if (!state.editMode) {
        state.editedFields = {};
      }
    },
    setToggleEditMode(state, action: PayloadAction<boolean>) {
      state.editMode = action.payload;
      // if (!state.editMode) {
      //   state.editedFields = {};
      // }
    },
    updateClaimDataField(
      state: IPreAuthClaimState,
      action: PayloadAction<{
        sectionKey: keyof PreAuthClaimResponse; // Type-safe section keys
        fieldId: string | undefined;
        updateValues: any;
        documentUrl: string;
        visitType: string | undefined;
      }>
    ) {
      const { sectionKey, fieldId, updateValues, documentUrl, visitType } =
        action.payload;

      // Ensure dischargeData is not null
      if (!state.preAuthClaimRes) {
        console.error("PreAuth Claim data is not available.");
        return;
      }

      // Update the specific field in the correct section
      // const currentSection = state.allWizardSteps.find(item => item.step === state.activeStep);
      // const Allfields = currentSection ? state.preAuthClaimRes[sectionKey]?.[0]?.[currentSection.title] : null;
      const Allfields = visitType
        ? state?.preAuthClaimRes?.[sectionKey]?.[0]?.[visitType]
        : null;

      if (Allfields) {
        const fieldToUpdate = Allfields?.find(
          (item) => item.id === fieldId && item?.data === documentUrl
        );

        if (fieldToUpdate && fieldToUpdate?.data) {
          fieldToUpdate.data = updateValues.data;
          fieldToUpdate.documentName = updateValues.documentName;
          fieldToUpdate.type =
            fieldToUpdate.type == "document-show"
              ? "document-upload"
              : fieldToUpdate.type;
        }
      }
    },
    updateEchsClaimDataField(
      state: IPreAuthClaimState,
      action: PayloadAction<{
        sectionKey: keyof PreAuthClaimResponse; // Type-safe section keys
        fieldId: string | undefined;
        updateValues: any;
        documentUrl: string;
        visitType: string | undefined;
      }>
    ) {
      const { sectionKey, fieldId, updateValues, documentUrl, visitType } =
        action.payload;

      // Ensure dischargeData is not null
      if (!state.preAuthClaimRes) {
        console.error("PreAuth Claim data is not available.");
        return;
      }

      const echsClaimData: any = state?.preAuthClaimRes?.[sectionKey];

      // Update the specific field in the correct section
      // const currentSection = state.allWizardSteps.find(item => item.step === state.activeStep);
      // const Allfields = currentSection ? state.preAuthClaimRes[sectionKey]?.[0]?.[currentSection.title] : null;

      const Allfields = visitType ? echsClaimData?.[visitType] : null;

      if (Allfields) {
        const fieldToUpdate = Allfields?.["Document Details"]?.find(
          (item: any) => item.id === fieldId && item?.data === documentUrl
        );

        if (fieldToUpdate && fieldToUpdate?.data) {
          fieldToUpdate.data = updateValues.data;
          fieldToUpdate.documentName = updateValues.documentName;
          fieldToUpdate.type =
            fieldToUpdate.type == "document-show"
              ? "document-upload"
              : fieldToUpdate.type;
        }
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getClaimSubmission.pending, (state) => {
        state.isFetchingClaimData = true;
        state.preAuthClaimRes = null;
        state.error = null;
        state.isLoading = true;
      })
      .addCase(
        getClaimSubmission.fulfilled,
        (state, action: PayloadAction<IClaimSubmissionResponse>) => {
          state.isFetchingClaimData = false;
          state.isLoading = false;
          if (action.payload?.claimSubmissionRes) {
            state.preAuthClaimRes = action.payload?.claimSubmissionRes;
          }
        }
      )
      .addCase(getClaimSubmission.rejected, (state, action) => {
        state.isFetchingClaimData = false;
        state.error = action.error.message || "An unknown error occurred";
        state.isLoading = false;
      })
      .addCase(submitClaimSubmission.pending, (state) => {
        state.isSubmit = true;
      })
      .addCase(
        submitClaimSubmission.fulfilled,
        (state, action: PayloadAction<IClaimSubmissionResponse>) => {
          state.isSubmit = false;
        }
      )
      .addCase(submitClaimSubmission.rejected, (state, action) => {
        state.isSubmit = false;
      })
      .addCase(updateClaimSubmission.pending, (state) => {
        state.isSubmit = true;
      })
      .addCase(
        updateClaimSubmission.fulfilled,
        (state, action: PayloadAction<IClaimSubmissionResponse>) => {
          state.isSubmit = false;
        }
      )
      .addCase(updateClaimSubmission.rejected, (state) => {
        state.isSubmit = false;
      })
      .addCase(fetchSchemeById.pending, (state) => {
        state.isFetchingSchemeById = true;
      })
      .addCase(
        fetchSchemeById.fulfilled,
        (state, action: PayloadAction<ISchemeOnBoardById>) => {
          state.isFetchingSchemeById = false;
          if (action.payload?.schemeRes) {
            state.selectedScheme = action?.payload?.schemeRes;
          }
        }
      )
      .addCase(fetchSchemeById.rejected, (state) => {
        state.isFetchingSchemeById = false;
        state.error = "Unable to Fetch scheme on board by id";
      })

      .addCase(fetchProcedureList.pending, (state) => {
        state.isFetchingProcedure = true;
      })
      .addCase(
        fetchProcedureList.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingProcedure = false;
          if (action.payload) {
            state.CasePreAuthRes = action?.payload?.procedureListRes;
          }
        }
      )
      .addCase(fetchProcedureList.rejected, (state) => {
        state.isFetchingProcedure = false;
        state.error = "Unable to Fetch Procedure list";
      })

      //echs procedure dropdown
      .addCase(fetchEchsProcedure.pending, (state) => {
        state.isFetchingProcedure = true;
      })
      .addCase(
        fetchEchsProcedure.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingProcedure = false;
          if (action.payload) {
            state.procedureDropDown = action?.payload?.procedures || [];
          }
        }
      )
      .addCase(fetchEchsProcedure.rejected, (state) => {
        state.isFetchingProcedure = false;
        state.error = "Unable to Fetch Echs Procedure";
      })

      //cghs procedure
      .addCase(fetchProcedure.pending, (state) => {
        state.isFetchingProcedure = true;
        state.procedureDropDown = [];
        state.referralProcedures = [];
      })
      .addCase(
        fetchProcedure.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingProcedure = false;
          if (action.payload) {
            state.procedureDropDown =
              action?.payload?.procedures?.allProcedures || [];
            state.referralProcedures =
              action.payload?.procedures?.referralProcedures;
          }
        }
      )
      .addCase(fetchProcedure.rejected, (state) => {
        state.isFetchingProcedure = false;
        state.error = "Unable to Fetch Procedure list";
         state.procedureDropDown = [];
        state.referralProcedures = [];
      })

      //cghs ab portal
      .addCase(fetchProcedureNew.pending, (state) => {
        state.isFetchingProcedure = true;
        state.procedureDropDown = [];
        state.referralProcedures = [];
      })
      .addCase(
        fetchProcedureNew.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingProcedure = false;
          if (action.payload) {
            state.procedureDropDown =
              action?.payload?.procedures?.allProcedures || [];
            state.referralProcedures =
              action.payload?.procedures?.referralProcedures;
          }
        }
      )
      .addCase(fetchProcedureNew.rejected, (state) => {
        state.isFetchingProcedure = false;
        state.error = "Unable to Fetch Procedure list";
         state.procedureDropDown = [];
        state.referralProcedures = [];
      })

      .addCase(UploadDocument.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        UploadDocument.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
        }
      )
      .addCase(UploadDocument.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const {
  setWizardSteps,
  updateWizardStep,
  completeWizardStep,
  addPreAuthClaimUploadedFile,
  removePreAuthClaimUploadedFile,
  resetLocalFiles,
  updateField,
  saveChanges,
  resetEditedFields,
  setUploadedDocumentUrl,
  toggleEditMode,
  setToggleEditMode,
  updateClaimDataField,
  updateEchsClaimDataField,
  resetPreAuthClaimRes,
  addProcedure,
  resetProcedureDropdown
} = preAuthClaimSlice.actions;

export default preAuthClaimSlice.reducer;
